export default __webpack_public_path__ + "static/media/advcoruja-modal.156285e1.png";